import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Warehouse, Wrench, Car } from '@phosphor-icons/react';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import EquipmentPage from './EquipmentPage';
import VehiclesPage from './VehiclesPage';
import MaterialsStockPage from './MaterialsStockPage';
import VerticalTabs from '../components/VerticalTabs';

const ResourcesPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlTab = searchParams.get('tab');
  // Migrate legacy 'stocks' tab to materiaux_stocks. Catalogue moved to /projects?tab=catalogue.
  const initialTab = (urlTab === 'stocks' || urlTab === 'catalogue') ? 'materiaux_stocks' : (urlTab || 'materiaux_stocks');
  const [mainTab, setMainTab] = useState(initialTab);
  const { t } = useLanguage();
  const { user } = useAuth();
  // isAdmin no longer used since catalogue moved to SiteManagementPage
  void user;

  useEffect(() => {
    if (!urlTab) return;
    const resolved = (urlTab === 'stocks' || urlTab === 'catalogue') ? 'materiaux_stocks' : urlTab;
    if (resolved !== mainTab) setMainTab(resolved);
  }, [urlTab, mainTab]);
  const handleTabChange = (v) => { setMainTab(v); setSearchParams({ tab: v }, { replace: true }); };

  const TABS = [
    { key: 'materiaux_stocks', label: 'Stocks matériaux', icon: Warehouse },
    { key: 'materiel', label: t('tab.equipment'), icon: Wrench },
    { key: 'vehicules', label: t('tab.vehicles'), icon: Car },
  ];

  return (
    <div data-testid="resources-page">
      <div className="page-header">
        <h1 className="page-title">{t('page.resources')}</h1>
        <p className="page-subtitle">{t('page.resources_sub')}</p>
      </div>

      <VerticalTabs tabs={TABS} activeTab={mainTab} onTabChange={handleTabChange}>
        {mainTab === 'materiaux_stocks' && <MaterialsStockPage />}
        {mainTab === 'materiel' && <EquipmentPage embedded />}
        {mainTab === 'vehicules' && <VehiclesPage embedded />}
      </VerticalTabs>
    </div>
  );
};

export default ResourcesPage;
